export default "data:text/javascript;base64,aW1wb3J0IFRTbGlkZU91dCBmcm9tICIuL1RTbGlkZU91dC52dWUiOwoKZXhwb3J0IGRlZmF1bHQgVFNsaWRlT3V0Owo="